import React from "react";
import { ConfirmationDialog } from "../../../../dialogs/confirmation-dialog";
import { FormattedMessage } from "react-intl";
import { useMutation } from "@apollo/client";
import { DELETE_CHAT } from "../../../../../apollo-client/mutations";
import { GET_USER_CHATS } from "../../../../../apollo-client/queries";
import { showSuccessToast } from "../../../../../toast/toast-service";
import { useChatStore } from "../../../../../store/chatStore";

export const ChatDeleteDialog = ({
  isOpen,
  toggle,
  chosenChat,
}) => {
  const { selectChat, updateChosenChat } = useChatStore();

  const [deleteCh] = useMutation(DELETE_CHAT, {
    variables: { id: chosenChat.chatId },
    refetchQueries: [GET_USER_CHATS, "getUserChats"],
  });

  const deleteChat = async () => {
    const data = await deleteCh();
    showSuccessToast(<FormattedMessage id="chat.delete-chat.successful" />);

    const newChosenChat = data?.data?.deleteChat?.chats?.chats?.[0];

    if (!newChosenChat) {
      // Clear chosen chat in store
      updateChosenChat({ chatId: null, chatTitle: null });
    } else {
      selectChat(newChosenChat);
    }

    toggle();
  };

  return (
    <ConfirmationDialog
      title={<FormattedMessage id="chat.delete-chat" />}
      isOpen={isOpen}
      toggle={toggle}
      content={<FormattedMessage id="chat.delete-chat.text" />}
      action={deleteChat}
    />
  );
};
